// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/resizable-header/resizable-header.less
// module id = 3234
// module chunks = 0